import { useEffect, useState } from "react";
import { api } from "./api";

/** SATU sumber daftar cabang untuk semua dropdown.
 *
 * Dulu 12 halaman memegang salinan hardcode
 * ["ZOA GROUP","BEBE","ZONA","UP.Gadget","UPPLESORIES"] masing-masing —
 * cabang baru yang dibuat owner di Master Data > Cabang tidak pernah muncul
 * di form mana pun. Sekarang semuanya membaca GET /inventory/cabang-options
 * (gabungan master cabang HRIS + cabang karyawan + cabang gudang, ejaan
 * di-dedup case-insensitive di backend, cukup login tanpa izin khusus).
 *
 * Daftar lama dipertahankan HANYA sebagai fallback saat request gagal
 * (offline/error) supaya form tidak mendadak kosong.
 */
// EJAANNYA WAJIB SAMA PERSIS dengan `CABANG_BAKU` di
// `backend/routers/inventory/warehouses.py`, `db.branches.name`, dan `BRANDS`
// di `backend/routers/finance/_shared.py`.
//
// Sampai 21 Agu 2026 daftar ini berisi "BEBE"/"ZONA"/"UPPLESORIES" sementara
// master cabang & Finance menulis "Bebefone"/"Zona Gadget"/"Upplesories".
// Karena dedup cabang case-insensitive, keduanya dihitung sebagai cabang
// BERBEDA — dropdown menawarkan dua-duanya, dan 46 dari 61 karyawan terlanjur
// memilih varian kiri yang tidak akan pernah cocok dengan `sales.branch`.
// Akibatnya lingkup data "hanya cabang saya" mengembalikan NOL baris untuk
// mereka, tanpa error dan tanpa gejala apa pun.
//
// Data produksi sudah diseragamkan dan `CABANG_BAKU` ikut diperbaiki, tapi
// daftar fallback ini sempat terlewat: begitu `/inventory/cabang-options`
// gagal dimuat sekali saja, pengguna kembali disodori ejaan lama — dan sejak
// validasi cabang diperketat, pilihan itu ditolak backend sebagai "tidak
// dikenal". Dijaga `backend/tests/test_kosakata_cabang_konsisten.py`.
const FALLBACK = ["ZOA GROUP", "Bebefone", "Zona Gadget", "UP.Gadget", "Upplesories"];

let _cache = null;
let _inflight = null;

export function ambilCabangOptions() {
  if (_cache) return Promise.resolve(_cache);
  if (!_inflight) {
    _inflight = api.get("/inventory/cabang-options")
      .then(r => {
        const items = (r.data?.items || []).filter(Boolean);
        if (items.length) _cache = items;   // jangan cache respons kosong
        return _cache || FALLBACK;
      })
      .catch(() => FALLBACK)                 // gagal = fallback, TANPA cache (retry di mount berikutnya)
      .finally(() => { _inflight = null; });
  }
  return _inflight;
}

/** Hook dropdown cabang. `denganKosong` menambah opsi "" di depan (untuk
 *  filter "semua cabang" — pola daftar lama yang berawalan ""). */
export function useCabangOptions({ denganKosong = false } = {}) {
  const [opsi, setOpsi] = useState(_cache || FALLBACK);
  useEffect(() => {
    let hidup = true;
    ambilCabangOptions().then(o => { if (hidup) setOpsi(o); });
    return () => { hidup = false; };
  }, []);
  return denganKosong ? ["", ...opsi] : opsi;
}
